<template>
  <div>
    <OperationsDeliverOrderView v-if="$getConstRole('ROLE_OPERATIONS') == role"></OperationsDeliverOrderView>
    <AdminDeliverOrderView v-if="$getConstRole('ROLE_ADMIN') == role"></AdminDeliverOrderView>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OperationsDeliverOrderView from '@/views/operations/DeliveryOrderView.vue'
import AdminDeliverOrderView from '@/views/admin/dispatch/DeliveryOrderView.vue'

export default {
  name: 'DeliverOrderView',
  data: () => ({
    role: 0
  }),
  computed: {
    ...mapGetters(['getCurrentUser']),
  },
  mounted () {
    this.role = this.getCurrentUser.role
  },
  methods: {
  },
  components: {
    OperationsDeliverOrderView,
    AdminDeliverOrderView
  },
};
</script>
